var exports = {
  "HU": "x112a1f60--831184--aside",
  "qf": "x112a1f60--831184--sticky",
  "DW": "x112a1f60--831184--sticky-top-space",
};

module.exports = exports;
